import { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import './index.scss'

import AppHeader from '../../components/Header'
import AppFooter from '../../components/Footer'

import ABOUTCONFIG from '../../configs/about'

class About extends Component {

  state = {
    activeIndex: 0
  }

  componentDidMount () {
    document.getElementById('root').scrollTop = 0

    let { type = 0 } = this.props.location.state || {}
    this.setState({ activeIndex: type })
  }

  handleChangeMenu (index) {
    this.setState({ activeIndex: index })
    document.getElementById('root').scrollTop = 0
  }

  render () {
    let { lang } = this.props
    let { activeIndex } = this.state
    let { title, info } = ABOUTCONFIG
    let infoTitle = info.map(item => { return item.title })
    let infoDetail = info[activeIndex]
    return (
      <div className='app-page page-about'>
        <AppHeader />
        <div className='page-container'>
          <div className='about-header box background-image' style={{ backgroundImage: `url(${title.background})` }}>
            <div className='box-content flex-align-justify'>{title[lang]}</div>
          </div>
          <div className='about-tab flex-justify'>
            {
              infoTitle.map((item, index) => {
                return (
                  <div className={`tab-item ${index === activeIndex ? 'active' : ''}`} key={index} onClick={this.handleChangeMenu.bind(this, index)}>
                    <div className='item-text'>{item[lang]}</div>
                  </div>
                )
              })
            }
          </div>
          <div className='flex-justify'>
            <div className='about-container max-width flex flex-align-start'>
              <div className='about-content flex-one'>
                <div className='content-title'>{infoDetail.title[lang]}</div>
                {
                  infoDetail.content.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        {item.type === 'subtitle' && <div className='content-subtitle'>{item[lang]}</div>}
                        {item.type === 'paragraph' && <div className='content-paragraph'>{item[lang]}</div>}
                        {item.type === 'image' && <img className='content-image' alt='' src={item.src}></img>}
                      </Fragment>
                    )
                  })
                }
              </div>
              <div className='about-menu page-menu'>
                {
                  infoTitle.map((item, index) => {
                    return (
                      <div className={`menu-item flex-align ${index === activeIndex ? 'active' : ''}`} key={index} onClick={this.handleChangeMenu.bind(this, index)}>
                        <div className='item-text'>{item[lang]}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(About)
